var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrandassetsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_asset",
    transform: "translate(-11.747 -0.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 24,
    height: 24,
    transform: "translate(11.747 0.146)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M-10.412-1.777a1.083,1.083,0,0,0-.709-.266H-12.3a7.278,7.278,0,0,1-4.958-2.073,1.091,1.091,0,0,0-.775-.327,1.092,1.092,0,0,0-.775.328,7.279,7.279,0,0,1-4.957,2.072h-1.177a1.084,1.084,0,0,0-.709.265,1.114,1.114,0,0,0-.382.843V2.84A12.38,12.38,0,0,0-18.376,14.7a1.061,1.061,0,0,0,.346.058,1.036,1.036,0,0,0,.338-.055A12.38,12.38,0,0,0-10.03,2.84V-.935a1.113,1.113,0,0,0-.382-.842M-10.83,2.84a11.526,11.526,0,0,1-7.115,11.1.263.263,0,0,1-.085.014h0a.267.267,0,0,1-.088-.015A11.526,11.526,0,0,1-25.23,2.84V-.935a.314.314,0,0,1,.107-.239.28.28,0,0,1,.184-.069h1.177a8.118,8.118,0,0,0,5.53-2.314.287.287,0,0,1,.4,0A8.118,8.118,0,0,0-12.3-1.243h1.177a.283.283,0,0,1,.185.07.314.314,0,0,1,.106.238Z",
    transform: "translate(41.777 6.79)",
    fill: "#0a3b58"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandassetsb);
export default __webpack_public_path__ + "static/media/brandassetsb.0f61e202e77b44e43938ef0edbb5f4b2.svg";
export { ForwardRef as ReactComponent };